var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","fill":"rgb(238, 53, 93)","d":"M6.839,9.384 C5.952,8.561 4.520,7.051 3.564,6.090 C2.610,5.197 1.996,5.953 0.836,7.188 C-0.460,8.492 0.836,9.178 2.678,11.032 L6.020,14.395 C7.249,15.493 8.272,13.845 9.909,12.266 L16.594,5.473 C18.709,3.414 19.187,3.414 17.481,1.766 C15.980,0.188 16.049,0.188 13.661,2.658 C12.569,3.688 7.181,9.178 6.839,9.384 Z"}));
}

Check.defaultProps = {"width":"19px","height":"15px"};

module.exports = Check;

Check.default = Check;
